import MtPannel from './pannel/Pannel.vue'
import MtIcon from './icon/Icon.vue'
import MtCheckbox from './checkbox/Checkbox.vue'
import MtRadioButton from './radio-button/RadioButton.vue'
import MtTooltip from './tooltip/Tooltip.vue'
import MtButton from './button/Button.vue'
import MtNotiBanner from './noti-banner/NotiBanner.vue'
import MtNotiFlag from './noti-flag/'
import MtNotiInline from './noti-inline/'
import MtLogo from './logo/Logo.vue'
import MtModal from './modal/Modal.vue'
import MtConfirm from './confirm/'
import MtTable from './table/Table.vue'
import MtScrollTrans from './scroll-trans/ScrollTrans.vue'
import MtInput from './input/Input.vue'
import MtSelect from './select/Select.vue'
import MtProgress from './progress/Progress.vue'
const components = [
  MtPannel,
  MtIcon,
  MtCheckbox,
  MtRadioButton,
  MtTooltip,
  MtButton,
  MtLogo,
  MtNotiBanner,
  MtNotiFlag,
  MtNotiInline,
  MtModal,
  MtConfirm,
  MtTable,
  MtScrollTrans,
  MtInput,
  MtSelect,
  MtProgress
]

const MtUI = {
  install(Vue, options) {
    components.map(component => {
			Vue.component(component.name, component)
		})
    Vue.prototype.$mtNotiFlag = MtNotiFlag.flag
    Vue.prototype.$mtNotiInline = MtNotiInline.inline
    Vue.prototype.$mtConfirm = MtConfirm.mtConfirm
    Vue.prototype.$mtAlert = MtConfirm.mtAlert
  }
};

export default MtUI



// WEBPACK FOOTER //
// ./src/plugins/mtui/index.js